import HistoryAndCommentLoader from "./HistoryCommentTemplate";
import FilterLoader from "./FilterLoaderTemplate";
import ListingLoaderTemplate from "./ListingTemplate";
import AgeingLoaderTemplate from "./AgeingTemplate";
import NotificationTemplate from "./NotificationTemplate";
import SideBarListingTemplate from "./SideBarListingLoaderTemplate";
import MeetingLoaderTemplate from "./MeetingLoaderTemplate";
import IssueListingTemplate from "./IssueListTemplate";
import IssuePendingLoader from "./IssuePendingLoader";
import IssueCategoryLoader from "./IssueCategoryLoader";
import AgendaListTemplate from "./AgendaListTemplate";
import IssueDetailLoader from "./IssueDetailLoader";
import ProjectDetailLoader from "./ProjectDetailLoader";
import ActionLoaderTemplate from "./ActionsLoaderTemplate";
import ProjectInfoTemplate from "./ProjectDetailInfoTemplate";
import SelectIssueTemplate from "./SelectIssueTemplate";
import KanbanLoader from "./KanbanLoader";
import UserProfileTemplate from "./UserProfileTemplate";
import LoadingTemplate from "./LoadingTemplate";

export {
  HistoryAndCommentLoader,
  FilterLoader,
  ListingLoaderTemplate,
  AgeingLoaderTemplate,
  NotificationTemplate,
  SideBarListingTemplate,
  MeetingLoaderTemplate,
  IssueListingTemplate,
  IssuePendingLoader,
  IssueCategoryLoader,
  AgendaListTemplate,
  IssueDetailLoader,
  ProjectDetailLoader,
  ActionLoaderTemplate,
  ProjectInfoTemplate,
  SelectIssueTemplate,
  LoadingTemplate,
  UserProfileTemplate,
  KanbanLoader
};
